import { useState } from "react";
import ExpenseForm from "./ExpenseForm";
import IncomeForm from "./IncomeForm";
import TransferForm from "./TransferForm";
import TransactionList from "./TransactionList";
import "./Transactions.css";

export default function Transactions(){

  const [tab,setTab] = useState("EXPENSE");

  return (
    <div className="card">
      <div className="card-title">Add Transaction</div>
    
      {/* Tabs */}
      <div className="transactions-tabs">
        {["EXPENSE","INCOME","TRANSFER","TRANSACTION_LIST"].map(t=>(
          <button
            key={t}
            className={`tab-btn ${tab===t ? "active":""}`}
            onClick={()=>setTab(t)}
          >
            {t.replace("_"," ")}
          </button>
        ))}
      </div>

      {/* Forms */}
      {tab === "EXPENSE" && <ExpenseForm />}
      {tab === "INCOME" && <IncomeForm />}
      {tab === "TRANSFER" && <TransferForm />}
      {tab === "TRANSACTION_LIST" && <TransactionList />}
    </div>
  );
}
